import { FC } from 'react';

import { SelectSort, SwitchGridList } from '../../../shared/ui';

import { SelectMember } from '../../../features/team-members';
import { FILTER_TEMPLATE_ITEMS } from '../../../entities/templates';

import { SORT_ITEMS, TemplatesTab } from '../config';
import { useView } from '../hooks';

type TemplatesFiltersProps = {
  onOwnerChange: (ownerId: string) => void;
  onSortChange: (sort: keyof typeof SORT_ITEMS) => void;
  onFilterChange: (filter: keyof typeof FILTER_TEMPLATE_ITEMS) => void;

  type: TemplatesTab;

  filterByOwner: string;
  sort: keyof typeof SORT_ITEMS;
  filter: keyof typeof FILTER_TEMPLATE_ITEMS;
};

export const TemplatesFilters: FC<TemplatesFiltersProps> = ({
  filterByOwner,
  sort,
  filter,
  type,
  onOwnerChange,
  onSortChange,
  onFilterChange,
}) => {
  const { view, setView } = useView();
  return (
    <div className="flex-grow-1 md:ml-0 ml-auto flex-nowrap gap-x-3 items-center flex">
      <SelectSort
        value={filter}
        onChange={onFilterChange}
        items={FILTER_TEMPLATE_ITEMS}
        className="lg:hidden"
      />
      {type === TemplatesTab.TEAM && (
        <SelectMember
          value={filterByOwner}
          onChange={onOwnerChange}
          className="lg:hidden"
        />
      )}
      <SelectSort
        value={sort}
        onChange={onSortChange}
        items={SORT_ITEMS}
        className="md:w-full"
      />
      <SwitchGridList
        value={view}
        onChange={(value) => setView(value)}
        className="xl:hidden"
      />
    </div>
  );
};
